export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full h-screen min-h-[600px] overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/a653579f633fec65ea0ae3250a06eadc.jpg"
          alt="DSS DOO hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-6 text-center">
        {/* Label */}
        <div className="mb-6 border border-white/30 rounded-full px-4 py-1.5">
          <span className="text-white/70 text-xs tracking-[0.2em] uppercase font-light">
            iOS Application Development
          </span>
        </div>

        {/* Main Title */}
        <h1 className="text-white font-semibold leading-tight tracking-tight mb-6"
          style={{ fontSize: "clamp(2.5rem, 6vw, 5rem)" }}>
          DSS DOO
        </h1>

        {/* Subtitle */}
        <p className="text-white/75 font-light leading-relaxed max-w-xl"
          style={{ fontSize: "clamp(1rem, 2vw, 1.2rem)" }}>
          A team of experts building modern iOS applications that elevate user experience and strengthen mobile security.
        </p>

        {/* Scroll cue */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-60">
          <span className="text-white text-xs tracking-widest uppercase">Scroll</span>
          <div className="w-px h-10 bg-white/50 animate-pulse" />
        </div>
      </div>
    </section>
  );
}
